import { render, staticRenderFns } from "./new-subbucket-folder.html?vue&type=template&id=5a48a7cc&scoped=true&external"
import script from "./new-subbucket-folder.js?vue&type=script&lang=js&external"
export * from "./new-subbucket-folder.js?vue&type=script&lang=js&external"
import style0 from "./new-subbucket-folder.scss?vue&type=style&index=0&id=5a48a7cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48a7cc",
  null
  
)

export default component.exports